export default __webpack_public_path__ + "static/media/massimiliano.8487a4ba.png";